"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _jsxRuntime = require("react/jsx-runtime");

/**
 * Values ​​that come from the backend are translated
 * @param {string} text
 */
var ValueTextMapping = function ValueTextMapping(_ref) {
  var text = _ref.text;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var translateNs = 'pc-matching:generic';

  var mapping = function mapping(text) {
    var ret = '';

    switch (text) {
      case 'YES':
        ret = t("".concat(translateNs, ".yes"));
        break;

      case 'NO':
        ret = t("".concat(translateNs, ".no"));
        break;

      case 'ARRANGEABLE':
        ret = t("".concat(translateNs, ".ARRANGEABLE"));
        break;

      default:
        ret = text.split('\n').map(function (line, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            children: [line, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {})]
          }, "vtm".concat(index));
        });
        break;
    }

    return ret;
  };

  return mapping(text);
};

var _default = /*#__PURE__*/_react.default.memo(ValueTextMapping);

exports.default = _default;